import React, { Fragment } from "react"

import ContentLoaderLines from "../../../common/content-loading/ContentLoaderLines"
import { Code, shapesOf } from "../rendered-listing-pattern"

// The view counterpart of SourceEditRenderedListingDetails, in the same place, order and words.
// The pages the scraper renders after the source URL: each listing page once, and not the source URL again.
const extraPages = (url, listingUrls) =>
    [...new Set((listingUrls || []).map((page) => page.trim()))].filter(
        (page) => page && page !== (url || "").trim()
    )

// What the link pattern collects: the shapes of the groups of links it was written from, as the edit panel shows
// them, or the pattern itself if it was written by hand
const Collects = ({ linkPattern }) => {
    if (!linkPattern) {
        return "Nothing: there's no link pattern, so the scraper records an error for this source"
    }
    const shapes = shapesOf(linkPattern)
    return shapes ? (
        <Fragment>
            Links that look like{" "}
            {shapes.map((shape, index) => (
                <Fragment key={shape}>
                    {index ? " or " : ""}
                    <Code>{shape}</Code>
                </Fragment>
            ))}
        </Fragment>
    ) : (
        <Fragment>
            Links that fully match <Code>{linkPattern}</Code>
        </Fragment>
    )
}

const SourceViewRenderedListingDetails = ({
    url,
    linkPattern,
    listingUrls,
    isFetching,
}) => (
    <div className="widget">
        <div className="widget-content">
            <h3 className="first-heading">
                <i className="icon icon-source" />
                Rendered listing
            </h3>
            <h3>
                <i className="icon icon-article" />
                Pages the scraper checks
            </h3>
            <ContentLoaderLines isFetching={isFetching}>
                {extraPages(url, listingUrls).length ? (
                    <ul>
                        <li>The source URL</li>
                        {extraPages(url, listingUrls).map((page) => (
                            <li key={page}>{page}</li>
                        ))}
                    </ul>
                ) : (
                    <p>Only the source URL</p>
                )}
            </ContentLoaderLines>
            <h3>
                <i className="icon icon-article" />
                What it collects
            </h3>
            <ContentLoaderLines isFetching={isFetching}>
                <p>
                    <Collects linkPattern={linkPattern} />
                </p>
            </ContentLoaderLines>
        </div>
    </div>
)

export default SourceViewRenderedListingDetails
